import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import MatomoTagManger from '../MatomoTagManger';
/** @namespace Bodymod/Matomo/Component/Matomo/Component */
export class MatomoComponent extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired
    };

    render() {
        const { children } = this.props;
        return (
            <>
                <MatomoTagManger />
                { children }
            </>
        );
    }
}

export default MatomoComponent;
